import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { WorkflowGeneralAttributesValidationErrors } from "@idw-types/common/validation/workflow-details-validation-errors";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";

export const getWorkflowAttributesValidationErrors = (axnuiContentLabelsAttributes: {[key in AttributeTypes]: string }, 
    activeAttributes: Array<FormattedRpServiceConfigurationAttribute>): WorkflowGeneralAttributesValidationErrors => {
    const validationErrors: {[id: string]: React.ReactNode} = {};
    let count = 0;

    activeAttributes.forEach(attribute => {
        if (axnuiContentLabelsAttributes[attribute.attributeType?.name] === "") {
            validationErrors[attribute.attributeType?.name] = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
            count++;
        } else {
            validationErrors[attribute.attributeType?.name] = null;
        }
    });

    return {
        count,
        validationErrors,
        tabTitle: <TabTitleWithErrorCount tabName={"Attributes"} errorCount={count}  />
    }
}